var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Bienvenido "),_c('b',[_vm._v("Credit Tools")]),_vm._v(" - herramienta para apoyar en Créditos.")])
}]

export { render, staticRenderFns }